import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-imperial-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=open]:bg-grid-100",
  {
    variants: {
      variant: {
        default:
          "bg-imperial-500 text-white shadow-sm hover:bg-imperial-400 focus-visible:ring-offset-0",
        secondary:
          "bg-grid-100 text-ink-900 hover:bg-grid-200 focus-visible:ring-offset-0",
        outline:
          "border border-grid-200 bg-white text-ink-900 shadow-sm hover:bg-grid-100 focus-visible:ring-offset-0",
        ghost: "text-ink-600 hover:bg-grid-100 hover:text-ink-900",
        subtle:
          "bg-stone-100 text-ink-800 hover:bg-stone-200 focus-visible:ring-offset-0",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-lg px-3",
        lg: "h-10 rounded-xl px-6 text-base",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
